import { Checkbox } from 'components/Inputs/Checkbox';
import { useUser } from 'hooks/useUser';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { IPartnerCreate } from 'types/Partner';

import { FormGroup, FormHelperText, FormLabel } from '@mui/material';
import FormControl from '@mui/material/FormControl';

export const PartnerTypeForm: React.FC = () => {
  const { isPartner } = useUser();
  const requiredFields = isPartner;
  const { trigger } = useFormContext<IPartnerCreate>();

  return (
    <Controller
      name="types"
      render={({ fieldState: { error } }) => (
        <FormControl
          component="fieldset"
          required={requiredFields}
          error={Boolean(error?.message)}
          onChange={() => {
            trigger('types');
          }}
        >
          <FormLabel component="legend">TIPO DE PARCEIRO</FormLabel>

          <FormGroup aria-label="position" row>
            <Checkbox
              name="types.petshop"
              label="Petshop"
              labelPlacement="end"
            />

            <Checkbox
              name="types.healthInstitution"
              label="Clínica ou hospital veterinário"
              labelPlacement="end"
            />

            <Checkbox
              name="types.sponsor"
              label="Patrocinador"
              labelPlacement="end"
            />

            <Checkbox name="types.others" label="Outros" labelPlacement="end" />
          </FormGroup>

          <FormHelperText>{error?.message}</FormHelperText>
        </FormControl>
      )}
    />
  );
};

